import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'
import { getCustomService } from '../../helpers/ReduxHelpers'
import { SendMessageParams } from '../../rest/requests/messages/sendMessage'

//
// requests
//

export const sendMessageService = getCustomService<
  'sendMessage',
  boolean,
  SendMessageParams
>('sendMessage')

//
// Initial state
//

type SendMessageState = {
  sendMessage: typeof sendMessageService.state
}

const initialState: SendMessageState = {
  sendMessage: sendMessageService.state,
}

//
// Slice (Actions & Reducers)
//

const slice = createSlice({
  name: 'mail',
  initialState,
  reducers: {
    ...sendMessageService.reducers,
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[slice.name]
const sendMessage = (state: RootState) => root(state).sendMessage

export const selectors = {
  sendMessage,
}
